import React from 'react';
import imgLogo from '../../../assets/img/logo.png';
import {I18nUtils} from "../../../i18n/I18nUtils";
import {connect} from "react-redux";
import Card from "../../shared/components/Card";
import CardBody from "../../shared/components/CardBody";
import {bindActionCreators} from "redux";
import * as authActions from '../actions/authActions';
import Row from "../../shared/components/Row";

class ResetPasswordScreen extends React.Component {

  constructor(props){
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    document.body.classList.add('login-page')
  }

  componentWillUnmount() {
    document.body.classList.remove('login-page')
  }

  onSubmit(event){
    event.preventDefault();

    const query = new URLSearchParams(this.props.location.search);
    const token = query.get('token');
    this.props.authActions.resetPassword(this.props.resetPassword, this.props.resetPasswordRepeat, token);
  }

  render() {
    return (
      <div className="login-box">
        <div className="logo">
          <img src={imgLogo} alt="Pavasal" className="img-responsive center-block m-b-15"/>
          <small>{I18nUtils.tr('TR_BIENVENIDO_AL_SISTEMA_DE_GESTION_DE_DOCUMENTACION')}</small>
        </div>
        <Card loading={this.props.loadingResetPassword}>
          <CardBody>
            <form onSubmit={this.onSubmit}>
              <div className="msg">
                {I18nUtils.tr('TR_ESCRIBE_TU_CONTRASENA_NUEVA')}
              </div>

              <div className="input-group">
                <span className="input-group-addon">
                    <i className="material-icons">lock</i>
                </span>
                <div className="form-line">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={I18nUtils.tr('TR_CONTRASENA_NUEVA')}
                    required
                    autoFocus
                    value={this.props.resetPassword}
                    onChange={(event) => {
                      this.props.authActions.changeResetPassword(event.target.value)
                    }}
                  />
                </div>
              </div>
              <div className="input-group">
                <span className="input-group-addon">
                    <i className="material-icons">lock</i>
                </span>
                <div className="form-line">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={I18nUtils.tr('TR_REPETIR_CONTRASENA_NUEVA')}
                    required
                    autoFocus
                    value={this.props.resetPasswordRepeat}
                    onChange={(event) => {
                      this.props.authActions.changeResetPasswordRepeat(event.target.value)
                    }}
                  />
                </div>
              </div>
              <button
                className="btn btn-block btn-lg bg-blue-grey waves-effect"
                type="submit"
                disabled={!this.props.btnEnabled}
              >{I18nUtils.tr('TR_CAMBIAR_CONTRASENA')}</button>
              <Row>
                <div className="col-md-12">
                  <p className={'text-error'}>{this.props.errorResetPassword}</p>
                </div>
              </Row>
            </form>
          </CardBody>
        </Card>
      </div>
    );
  }

}

const mapStateToProps = state => {
  const btnEnabled = state.auth.resetPassword && state.auth.resetPasswordRepeat;
  return({
    loadingResetPassword: state.auth.loadingResetPassword,
    errorResetPassword: state.auth.errorResetPassword,
    resetPassword: state.auth.resetPassword,
    resetPasswordRepeat: state.auth.resetPasswordRepeat,
    btnEnabled,
  });
};

const mapDispatchToProps = dispatch => ({
  authActions: bindActionCreators(authActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordScreen);



// WEBPACK FOOTER //
// ./src/app/login/screens/ResetPasswordScreen.js